module.exports = __webpack_public_path__ + "img/unifonic.05ac0de4.png";